// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-screen_container___WoKz"};